import { SetupGroupLayout } from '@/features/setup/routes/setup-group-layout';
export default SetupGroupLayout;
